import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import {
  ReactDefaultProps,
  ReactComponentStaticProps,
} from "../../types/react";

import LpgConfirmOutline from "../../icons/Lpg/ConfirmOutline";
import LpgCancelOutline from "../../icons/Lpg/CancelOutline";
import { Icon } from "../Icon";

import styles from "./ComparisonTable.scss";

export type ComparisonTableFeatureBooleanProps = {
  hasFeature?: boolean;
};

const defaultProps = {
  hasFeature: false,
} as const;

const validatedDefaultProps: ReactDefaultProps<ComparisonTableFeatureBooleanProps> = defaultProps;

export const ComparisonTableFeatureBoolean: ((
  props: ComparisonTableFeatureBooleanProps
) => JSX.Element) &
  ReactComponentStaticProps<ComparisonTableFeatureBooleanProps> = ({
  hasFeature = defaultProps.hasFeature,
}) => {
  return (
    <span
      className={cx(styles["feature-boolean"], {
        [styles["feature-boolean--green"]]: hasFeature,
      })}
    >
      <Icon
        icon={hasFeature ? LpgConfirmOutline : LpgCancelOutline}
        size={Icon.Size.parent}
      />
    </span>
  );
};

ComparisonTableFeatureBoolean.propTypes = {
  hasFeature: PropTypes.bool,
};

ComparisonTableFeatureBoolean.defaultProps = validatedDefaultProps;

ComparisonTableFeatureBoolean.displayName = "ComparisonTable.FeatureBoolean";

export default ComparisonTableFeatureBoolean;
